import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ authenticated }) => {
  return authenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
